import React from 'react';
import { Button } from "@/components/ui/Button";
import { ArrowRight, Smartphone, Globe, Cloud, Zap, Users, LineChart } from "lucide-react";

const services = [
  {
    title: "Applications Mobiles",
    description: "Développement d'applications mobiles natives et cross-platform pour iOS et Android, optimisées pour les performances.",
    icon: Smartphone,
    link: "/developpement-mobile"
  },
  {
    title: "Applications Web",
    description: "Développement d'applications web modernes et réactives, offrant une expérience utilisateur fluide sur tous les navigateurs.",
    icon: Globe,
    link: "/developpement-web"
  },
  {
    title: "Développement SaaS",
    description: "Création de solutions SaaS sur mesure, de l'architecture à la mise en production, avec une expertise en cloud et scalabilité.",
    icon: Cloud,
    link: "/developpement-saas"
  },
  {
    title: "Automatisation",
    description: "Solutions d'automatisation pour optimiser vos processus métier, réduire les coûts et augmenter la productivité.",
    icon: Zap,
    link: "/ia-automatisation"
  },
  {
    title: "Marketplaces",
    description: "Création de plateformes de marketplace connectant acheteurs et vendeurs, avec gestion des paiements et des transactions.",
    icon: Users,
    link: "/developpement-marketplace"
  },
  {
    title: "Maintenance & Support",
    description: "Services de maintenance proactive, monitoring et support technique pour garantir la performance de vos solutions.",
    icon: LineChart,
    link: "/maintenance-support"
  }
];

const ServicesSection = () => {
  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Nos Services
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Découvrez notre gamme complète de services numériques et trouvez des opportunités de partenariat dans votre domaine d'expertise.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-white rounded-xl border border-slate-200 p-6 hover:border-orcsys-500 transition-all duration-300 hover:shadow-lg"
            >
              <div className="bg-orcsys-50 p-3 rounded-lg w-fit mb-4 group-hover:bg-orcsys-100 transition-colors duration-300">
                <service.icon className="h-6 w-6 text-orcsys-500" />
              </div>
              <h3 className="text-xl font-semibold mb-3 group-hover:text-orcsys-500 transition-colors duration-300">
                {service.title}
              </h3>
              <p className="text-slate-600 mb-4">
                {service.description}
              </p>
              <Button 
                variant="ghost" 
                className="text-orcsys-500 p-0 hover:text-orcsys-600"
                onClick={() => window.location.href = service.link}
              >
                En savoir plus
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection; 